module.exports = __webpack_public_path__ + "assets/img/void.41126325.svg";